import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandler {
  constructor(private snackBar: MatSnackBar) { }

  showError(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, 
      panelClass: ['error-snackbar'], 
    });
  }

  logError(error: any): void {
    console.error('Error:', error);
  }
}
